// Keep a detached/unavailable product visible only in the row that already owns it.
// Disable the snapshot: changeProduct expects current catalogue prices, not saved totals.
export function historicalProductOptions(available, selected) {
  if (!selected || !selected.product_id) return available;
  const current = available.find(product => product.product_id === selected.product_id);
  if (current) {
    // The saved row owns its display name; choosing a current option keeps current prices.
    return current.name === selected.name ? available : available.map(product =>
      product.product_id === selected.product_id ? { ...product, name: selected.name } : product);
  }
  return available.concat([{ ...selected, disabled: true }]);
}

// A detached provider can disappear from the branch's current catalogue too.
// This option belongs only to the product snapshot that already references it.
export function historicalInsuranceProviderOptions(available, selected) {
  if (!selected || !selected.product_id || !selected.sub_category_id) return available;
  const id = typeof selected.sub_category_id === 'object'
    ? selected.sub_category_id.sub_category_id : selected.sub_category_id;
  if (!id || available.some(provider => provider.sub_category_id === id)) return available;
  return available.concat([{
    sub_category_id: id,
    name: selected.sub_category_name || id,
    disabled: true,
  }]);
}
